import { extend } from '../util';
import VueToast from './toast';
import Toaster from './toaster';
import "../style/components/toast.css";
var Toast = extend(VueToast, Toaster);
export { default as Toast } from './toast';
export { default as Toaster } from './toaster';
export default Toast;